import 'intersection-observer';
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'

// 样式导入顺序很重要
import './assets/main.css'  // Tailwind CSS
import 'vant/lib/index.css' // Vant UI
import '@/assets/styles/index.scss' // 其他样式

import {
  Button,
  Swipe,
  SwipeItem,
  Empty,    // 添加 Empty
  List,     // 添加 List
  PullRefresh, // 添加 PullRefresh
  Loading,   // 添加 Loading
  Icon,      // 添加 Icon
  Space,     // 添加 Space
  Form,      // 添加 Form
  Steps,     // 添加 Steps
  Step,      // 添加 Step
  Dialog,    // 添加 Dialog
  Image,     // 添加 Image
  CellGroup, // 添加 CellGroup
  Field,     // 添加 Field
  Popup,     // 添加 Popup
  Picker     // 添加 Picker
} from 'vant'

import ProductList from '@/components/ProductList.vue'

const app = createApp(App)
const pinia = createPinia()

// 使用持久化插件
pinia.use(piniaPluginPersistedstate)

// 添加全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('全局错误:', err)
  console.error('组件:', vm)
  console.error('信息:', info)
}

// 使用插件并挂载应用
app.use(Button)
   .use(Swipe)
   .use(SwipeItem)
   .use(Empty)     // 注册 Empty
   .use(List)      // 注册 List
   .use(PullRefresh) // 注册 PullRefresh
   .use(Loading)   // 注册 Loading
   .use(Icon)      // 注册 Icon
   .use(Space)     // 注册 Space
   .use(Form)      // 注册 Form
   .use(Steps)     // 注册 Steps
   .use(Step)      // 注册 Step
   .use(Dialog)    // 注册 Dialog
   .use(Image)     // 注册 Image
   .use(CellGroup) // 注册 CellGroup
   .use(Field)     // 注册 Field
   .use(Popup)     // 注册 Popup
   .use(Picker)    // 注册 Picker
   .use(pinia)
   .use(router)
   .component('product-list', ProductList)  // 全局注册
   .mount("#app")
